import AContainer from "../../library/ExtendedObjects/AContainer.js";
import AScene from "../../library/ExtendedObjects/AScene.js";
import BubbleArea from "./BubbleArea.js";
import EmojiArea from "./EmojiArea.js";
import TextArea from "./TextArea.js";

export default class SendArea
{
    /**
     * @param {AScene} scene 
     * @param {BubbleArea} bubbleArea 
     */
    constructor(scene, onTextSent, onImagesSent, bubbleArea)
    {
        this.scene = scene;
        this.textBg = this.scene.addImage(0, 0, "TextBar");
        // this.textBg.alpha = 0;
        // this.textBg.tint = 0xcdcdcd;
        this.onTextSent = onTextSent;
        this.onImagesSent = onImagesSent;
        this.sendButton = this.scene.addButton(0, 0, "SendButton_Circle", {tintOnDown: 0x198C76, scaleOnDown: .9}, ()=>{this.sendButton_Pressed();});
        this.bubbleArea = bubbleArea;

        this.sendButton.tint = 0xbbbbbb;
        this.sendArrow = this.scene.addImage(0, 0, "SendButton_Arrow");
        this.buttonGroup = this.scene.addContainer(312, 2, new AContainer(this.scene));
        this.buttonGroup.add(this.sendButton);
        this.buttonGroup.add(this.sendArrow);

        this.bottomHeight = 302;
        this.bottomBG = this.scene.createRect(-this.scene.mid.x, this.textBg.y - 1 + this.textBg.height * .5, this.scene.size.width, this.bottomHeight, 0xc1d3d1);
        this.bottomGroup = this.scene.add.container(0, this.bottomBG.y + this.textBg.height * .5);

        this.emoji_Group = new EmojiArea(this.scene, this, -this.scene.mid.x);
        this.bottomGroup.add(this.emoji_Group);

        this.text_Group = new TextArea(this.scene, this);
        this.bottomGroup.add(this.text_Group);

        this.toggleCanSend(false);
        this.textField = this.scene.addText(-300, 4, "", 25, {width: 520}, 0);
        this.textField.tint = 0x5B5959;
        this.textField.setOrigin(0, .5);

        this.imageField = this.scene.add.container(this.textBg.x - this.textBg.width * .5, this.textField.y - this.textBg.height * .5);
        this.inputArea = this.scene.add.container(this.scene.mid.x, this.scene.size.height - 74, [this.bottomBG, this.bottomGroup, this.textBg, this.buttonGroup, this.textField, this.imageField]);
        
        this.inputArea.originalY = this.inputArea.y;
        this.bubbleArea.originalY = this.bubbleArea.bottomY;
        
        this.emoji_Group.alpha = 0;
        this.text_Group.alpha = 0;
        this.displayedGroup = null;
    }

    destroy()
    {
        this.inputArea.destroy();
    }

    showEmojis(correctEmojis, bannedEmojis)
    {
        this.emoji_Group.populateEmojis(correctEmojis, bannedEmojis);
        this.toggleBottom(true, this.emoji_Group);
    }

    showTexts(correctText, incorrectTexts)
    {
        this.text_Group.populateTexts(correctText, incorrectTexts);
        this.toggleBottom(true, this.text_Group);
    }

    toggleBottom(toggle, displayedGroup)
    {
        this.scene.addTween(this.bubbleArea, 500, {bottomY: this.bubbleArea.originalY}, Phaser.Math.Easing.Sine.Out);
        this.scene.addTween(this.inputArea, 500, {y: this.inputArea.originalY}, Phaser.Math.Easing.Sine.Out, ()=>{
            if(this.displayedGroup != null)
            {
                this.displayedGroup.alpha = 0;
                this.displayedGroup.remove(displayedGroup);
            }

            if(toggle)
            {
                this.scene.addTween(this.bubbleArea, 500, {bottomY: this.bubbleArea.originalY - this.bottomHeight}, Phaser.Math.Easing.Sine.Out);
                this.scene.addTween(this.inputArea, 500, { y: this.inputArea.originalY - this.bottomHeight }, Phaser.Math.Easing.Sine.Out);

                this.displayedGroup = displayedGroup;
                this.displayedGroup.alpha = 1;
            }
        });
    }

    sendButton_Pressed()
    {
        let removedEmojis = this.emoji_Group.removeEmojisFromSubmit();

        if(this.textField.text == "")
        {
            this.onImagesSent(removedEmojis);
        } else {
            this.onTextSent(this.textField.text);
        }
        this.textField.text = "";
        this.text_Group.unselectText();
    }

    toggleCanSend(toggle)
    {
        if(this.canSend == toggle) return;
        this.scene.addTween(this.sendButton, 200, {tint: toggle ? 0x1ABA9B : 0xbbbbbb, scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Sine.Out);

        if(toggle)
        {   
            this.scene.addTween(this.buttonGroup, 200, {scaleX: 1.2, scaleY: 1.2}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.scene.addTween(this.buttonGroup, 700, {scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Bounce.Out);
            });
        }
        
        this.canSend = toggle;
        this.sendButton.setEnabled(toggle);
    }

    setText(text, canSend = true)
    {
        this.toggleCanSend((text != "" && canSend));
        this.textField.setTextTo(text);
    }

    update()
    {
        this.emoji_Group.update();
    }
}